import { Collapse } from "antd";

const { Panel } = Collapse;

export const CollapseComponent = ({
  style,
  classNameHeader,
  headerText,
  content,
  className2,
}) => {
  const callback = (key) => {};

  return (
    <Collapse
      style={style}
      defaultActiveKey={["1"]}
      onChange={callback}
      expandIconPosition="right"
    >
      <Panel
        className={
          null != className2
            ? className2 + " " + classNameHeader
            : classNameHeader
        }
        header={headerText}
        key="1"
      >
        <>{content}</>
      </Panel>
    </Collapse>
  );
};
